import img from "../../assets/newimg.webp";
function NotFound() {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: "50px",
        }}
      >
        <img
          src={img}
          alt="error image"
          style={{ width: "600px", height: "400px" }}
        />
        <h3 style={{ fontWeight: "bold", color: "#7860cc" }}>
          Ohh No! We flipped every page but couldn’t find this one.
        </h3>
      </div>
    </>
  );
}
export default NotFound;
